import { Component, OnInit, Input } from '@angular/core';

import { Setor } from "../shared/setor.model";
import { SetorNavigationService } from "../shared/setor-navigation.service";
import { UtilService } from "../../../shared/services/util.service";
import { SetorApiService } from "../shared/setor-api.service";
import { setoresModuleName } from "../shared/data.service";
import { SetorService } from "../shared/setor.service";
import { Divisao } from "../../divisoes/shared/divisao.model";

@Component({
  selector: 'app-setor-list',
  template: require('./setor-list.component.html'),
  styles: [require('./setor-list.component.css')]
})
export class SetorListComponent implements OnInit {
  @Input() list: Setor[] = [];
  @Input() divisaoObject: Divisao = new Divisao();
  @Input() showDisabled: boolean = true;

  setorModule: any = setoresModuleName;

  constructor(
    private _setorNavigationService: SetorNavigationService,
    private _setoresApiService: SetorApiService,
    private _setoreservice: SetorService,
    private _utilService: UtilService
  ) { }

  ngOnInit() {
  }

  clickNew() {
    this._setoreservice.setSessionStorageFatherModule( this.divisaoObject);
    this._setorNavigationService.goToNew();
  }

  clickEdit(item: Setor) {
    this._setoreservice.clearSessionStorage();
    this._setorNavigationService.goToEdit(item.id);
  }

  clickDelete(item: Setor) {
    var onDelete = (function() {
      this.onDelete(item);
    }.bind(this));

    this._utilService.swalMessageDelete(onDelete);
  }

  private onDelete(item: any) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        var x: number, lenX: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
          if (this.list[x].id === item.id) {
            this.list[x].ativo = false;
            break;
          }
        }
        this._utilService.swalMessageDeleteSuccess();
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._setoresApiService.onDelete(item.id, onDone);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/setores/setor-list/setor-list.component.ts
 **/